import { View } from "react-native";
import React, { useState } from "react";
import ZefixChooserButton from "../../zefix/ZefixChooser";
import Text from "../../components/Text";
import VStack from "../../ui_atoms/VStack";
import { getLegalFormName } from "../../zefix/LegalForm";
import type { Meta, StoryObj } from "@storybook/react";
import { ZefixCompany } from "../../zefix/ZefixAPI";

const ZefixChooserStoryComponent = () => {
    const language = "fr";
    const [value, setValue] = useState<ZefixCompany | null>(null);
    return (
        <View>
            <ZefixChooserButton
                onSelect={setValue}
                language={language}
                buttonLabel="Select company"
            />
            <VStack gap={0.5} h={0.5} v={1}>
                {value ? (
                    <>
                        <Text>UID (IDE): {value.uid}</Text>
                        <Text>Name: {value.name}</Text>
                        <Text>Seat: {value.legalSeat}</Text>
                        <Text>Legal form: {getLegalFormName(value.legalFormId, language)}</Text>
                    </>
                ) : (
                    <Text>not-set</Text>
                )}
            </VStack>
        </View>
    );
};

const meta = {
    title: "Components/Zefix",
    component: ZefixChooserStoryComponent,
    argTypes: {},
    decorators: [
        (StoryFn) => (
            <View style={{ flex: 1, justifyContent: "center", alignItems: "center", padding: 10 }}>
                <StoryFn />
            </View>
        ),
    ],
} satisfies Meta<typeof ZefixChooserStoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Basic: Story = {
    args: {},
};
